
import { useState } from "react";
import AlertsCustom from '../../../components/Alerts';
// ─────────────────────────────────────────────
// Componente principal
// ─────────────────────────────────────────────
export default function ResourceLayout({
    // --- dados
    resourceUsers = [],
    dynamicResources = {},
    domains = [],
    resourceConfig = {},
    resourceFields = {},
    selectedModels = {},
    resourceActivation = {},
    validationErrors = {},
    countries = [],
    countrySelections = {},
    domainSelections = {},
    expandedCards = {},

    // --- popup de novo grupo
    showPopup,
    setShowPopup,
    newBuName,
    setNewBuName,
    handleExitPopup,
    handleAddBusinessUnit,
    isSavingBu,
    popupDomainSelections = {},
    popupCountrySelections = [],
    togglePopupDomainSelection,
    togglePopupCountrySelection,
    selectedPopupResources = [],
    setSelectedPopupResources,
    formTocado,
    blockPopupSave,

    // --- popup de novo recurso
    showResourcePopup,
    setShowResourcePopup,
    newResourceSelections = [],
    setNewResourceSelections,
    handleAddResources,
    isSavingResources,
    resourceListError,
    resourcePopupAttemptedSubmit,
    editingCardId,
    setEditingCardId,
    handleExitResourcePopup,

    // --- handlers
    handleDeleteCard,
    handleDeleteResource,
    handleToggleActivation,
    handleResourceFieldChange,
    handleVerifyAndSaveResource,
    handleOpenModelSection,
    handleExitModelSection,
    showModelSection,
    toggleModelSelection,
    blockModelSave,
    isResourceFieldsFilled,
    searchTerm = "",
    setSearchTerm,

    // --- i18n (fallback para chave caso não exista tradução)
    tResource = (k) => k,

    handleModelValueChange,
    handleConfirmCardDelete,
    isDeleteCardModalOpen,
    handleCloseDeleteCardModal,
    handleCloseDeleteModal,
    isDeleteModalOpen,
    handleConfirmDelete,
    availableDomains,
    level,
    domainsAccess,

    alertMessage,
    setAlertMessage,
    alertType,
    setAlertType,
    alertTitle,
    setAlertTitle,
    showAlert,
    setShowAlert,


}) {
    const [selectedUserId, setSelectedUserId] = useState(null);
    const [selectedResourceId, setSelectedResourceId] = useState(null);

    const selectedUser = resourceUsers.find((u) => u.id === selectedUserId);

    const userDynamicResources = selectedUserId
        ? dynamicResources[selectedUserId] || []
        : [];

    const existingResourceTypes = userDynamicResources.map((r) => r.name);

    const availableDomainsForAdd = domains.filter((d) => {
        return !existingResourceTypes.includes(d.name);
    });

    const activeResource = userDynamicResources.find(
        (r) => r.id === selectedResourceId
    );

    // Ao trocar de usuário, resetar recurso selecionado
    function selectUser(id) {
        setSelectedUserId(id);
        setSelectedResourceId(null);
    }

    // ── campo genérico reutilizando exatamente a lógica atual ──
    function renderFields(user, resource) {
        const config = resourceConfig[resource.name];
        if (!config) return null;
        const isActivated = resourceActivation[resource.id] || false;
        const key = `${user.id}-${resource.id}`;
        const fields = config.fields || [];
        const val = (f) => resourceFields[key]?.[f] || "";
        const err = (f) => validationErrors[key]?.[f];
        const onChange = (f) => (e) =>
            handleResourceFieldChange(user.id, resource.id, f, e.target.value);

        const FIELD_META = {
            url: { label: tResource("label_url"), placeholder: tResource("placeholder_url") },
            key: { label: tResource("label_token"), placeholder: tResource("placeholder_token") },
            connexion_string: { label: tResource("label_token"), placeholder: tResource("placeholder_connection_string") },
            key_gemini: { label: "Gemini API Key", placeholder: "Gemini API Key" },
            function_key: { label: "Function Key", placeholder: "Function Key" },
            function_url: { label: "Function URL", placeholder: "Function URL" },
            connection_string: { label: "Connection String", placeholder: "Connection String" },
            container_name: { label: "Container Name", placeholder: "Container Name" },
            api_key: { label: "GPT API Key", placeholder: "GPT API Key" },
            deployment: { label: "Deployment", placeholder: "Deployment" },
            search_key: { label: "Search Key", placeholder: "Search Key" },
            index: { label: "Index", placeholder: "Index" },
            endpoint: { label: "Endpoint", placeholder: "Endpoint" },
            openai_endpoint: { label: "OpenAI Endpoint", placeholder: "OpenAI Endpoint" },
            openai_key: { label: "OpenAI Key", placeholder: "OpenAI Key" },
        };



        return (
            <div className="rl-fields-grid">
                {fields.map((f) => {
                    const meta = FIELD_META[f];
                    if (!meta) return null;
                    return (
                        <div className="rl-field-group" key={f}>
                            <label className="rl-label">{meta.label}</label>
                            <input
                                type="text"
                                placeholder={meta.placeholder}
                                className={`rl-input${err(f) ? " rl-input--error" : ""}`}
                                value={val(f)}
                                onChange={onChange(f)}
                                readOnly={isActivated}
                            />
                        </div>
                    );
                })}

                {/* Modelos */}
                {config.models && (
                    <div className="rl-field-group rl-field-group--full">
                        <label className="rl-label">
                            {tResource(
                                (selectedModels[key] || []).length > 1
                                    ? "label_models"
                                    : "label_model"
                            )}
                        </label>
                        {!isActivated && (
                            <input
                                type="text"
                                placeholder={tResource("select_models")}
                                className="rl-input rl-input--pointer"
                                readOnly
                                onClick={() => handleOpenModelSection(user.id, resource.id)}
                            />
                        )}
                        {(selectedModels[key] || []).length > 0 && (
                            <div className="rl-tags">
                                {selectedModels[key].map((modelId) => {
                                    const model = config.models.find((m) => m.id === modelId);
                                    if (!model) return null;
                                    return (
                                        <span key={model.id} className="rl-tag">
                                            {model.name}
                                            <button
                                                onClick={() =>
                                                    toggleModelSelection(user.id, resource.id, model.id)
                                                }
                                                disabled={isActivated}
                                            >
                                                ×
                                            </button>
                                        </span>
                                    );
                                })}
                            </div>
                        )}
                    </div>
                )}

                {!isActivated && (
                    <div className="rl-field-group rl-field-group--full">
                        <button
                            type="button"
                            className="rl-btn rl-btn--primary"
                            onClick={() => handleVerifyAndSaveResource(user.id, resource)}
                            disabled={
                                blockModelSave[key] && !isResourceFieldsFilled(user.id, resource)
                            }
                        >
                            {isSavingBu ? tResource("saving") : tResource("save")}
                        </button>
                    </div>
                )}
            </div>
        );
    }

    return (
        <>
            <style>{CSS}</style>

            {showAlert && (
                <AlertsCustom
                    type={alertType}
                    title={alertTitle}
                    message={alertMessage}
                    onClose={() => setShowAlert(false)}
                />
            )}

            <div className="rl-root">
                {/* ── SIDEBAR ── */}
                <aside className="rl-sidebar">
                    <div className="rl-sidebar-header">
                        <button
                            className="rl-btn-icon-header"
                            title={tResource("add_resource")}
                            onClick={() => setShowPopup(true)}
                        >
                            +
                        </button>
                        <div className="rl-sidebar-search">
                            <div className="rl-search-wrapper">
                                <img src="/imagens/search.svg" alt="" className="rl-search-icon" />
                                <input
                                    type="text"
                                    placeholder="Buscar..."
                                    className="rl-input rl-input--search"
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm && setSearchTerm(e.target.value)}
                                    style={{padding: "6.5px 0 6.5px 32px"}}
                                />
                            </div>
                        </div>
                    </div>

                    <ul className="rl-user-list">
                        {resourceUsers
                            
                            .filter((u) =>
                                (u.name || "").toLowerCase().includes(searchTerm.toLowerCase())
                            )
                            .filter((u) => !u.isBasic || level === 'dev')
                            .map((user) => (
                                <li
                                    key={user.id}
                                    className={`rl-user-item${selectedUserId === user.id ? " rl-user-item--active" : ""
                                        }`}
                                    onClick={() => selectUser(user.id)}
                                    style={user.isBasic ? { borderLeft: '3px solid #ff6432' } : {}}
                                >
                                    <span className="rl-avatar" style={user.isBasic ? { background: '#ff6432' } : {}}>
                                        {user.isBasic ? '★' : user.name?.[0]}
                                    </span>
                                    <span className="rl-user-name">{user.name}</span>
                                    {user.isBasic ? (
                                        <span style={{ fontSize: '10px', color: '#ff6432', fontWeight: 'bold' }}>DEV</span>
                                    ) : (
                                        <button
                                            className="rl-btn-icon rl-btn-icon--danger"
                                            title={tResource("delete")}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                handleDeleteCard(user.id);
                                            }}
                                        >
                                            ×
                                        </button>
                                    )}
                                </li>
                            ))}
                    </ul>
                </aside>

                {/* ── PAINEL PRINCIPAL ── */}
                <main className="rl-main">
                    {!selectedUser ? (
                        <div className="rl-empty">
                            <p>Selecione um grupo de recursos para gerenciar.</p>
                        </div>
                    ) : (
                        <>
                            <div className="rl-main-header">
                                <div className="rl-main-header-wrapper">
                                    <h2 className="rl-main-title">{selectedUser.name}</h2>
                                    {availableDomainsForAdd.length > 0 && (
                                        <button
                                            className="rl-btn rl-btn--secondary"
                                            onClick={() => {
                                                setEditingCardId(selectedUser.id);
                                                setShowResourcePopup(true);
                                            }}
                                        >
                                            {tResource("add_resource")}
                                        </button>
                                    )}
                                </div>
                            </div>

                            {/* TABS por tipo de recurso */}
                            <div className="rl-tabs">
                                {userDynamicResources.map((resource) => (
                                    <button
                                        key={resource.id}
                                        className={`rl-tab${selectedResourceId === resource.id ? " rl-tab--active" : ""
                                            }`}
                                        onClick={() => setSelectedResourceId(resource.id)}
                                    >
                                        {resource.name}
                                    </button>
                                ))}
                            </div>

                            {/* PAINEL DO RECURSO SELECIONADO */}
                            {activeResource ? (
                                (() => {
                                    const config = resourceConfig[activeResource.name];
                                    const isActivated =
                                        resourceActivation[activeResource.id] || false;
                                    const key = `${selectedUser.id}-${activeResource.id}`;
                                    const openAICount = userDynamicResources.filter(
                                        (r) => r.name === "OpenAI"
                                    ).length;
                                    const isDeletable =
                                        activeResource.name !== "OpenAI" || openAICount > 1;

                                    return (
                                        <div className="rl-resource-panel">
                                            <div className="rl-resource-panel-header">
                                                <div className="rl-resource-meta">
                                                    <span className="rl-resource-type">
                                                        {tResource("status")}
                                                    </span>
                                                </div>

                                                <div className="rl-resource-actions">
                                                    {/* Toggle ativo/inativo */}
                                                    <label className="rl-toggle">
                                                        <input
                                                            type="checkbox"
                                                            id={`dyn-${activeResource.id}`}
                                                            checked={isActivated}
                                                            onChange={() =>
                                                                handleToggleActivation(activeResource.id)
                                                            }
                                                        />
                                                        <span className="rl-toggle-slider" />
                                                    </label>

                                                    {/* Deletar */}
                                                    {isDeletable && (
                                                        <button
                                                            className="rl-btn--danger"
                                                            onClick={() =>
                                                                handleDeleteResource(
                                                                    selectedUser.id,
                                                                    activeResource.id,
                                                                    false
                                                                )
                                                            }
                                                        >
                                                            {tResource("remove") || "Remover"}
                                                        </button>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Seção de seleção de modelos (substitui o showModelSection inline) */}
                                            {showModelSection === key ? (
                                                <div className="rl-model-section">
                                                    <div className="rl-model-section-header">
                                                        <span style={{color: "#fff"}}>{tResource("select_models")}</span>
                                                        <button
                                                            className="rl-btn rl-btn--ghost"
                                                            onClick={handleExitModelSection}
                                                        >
                                                            ← {tResource("back")}
                                                        </button>
                                                    </div>
                                                    <div className="rl-model-list">
                                                        {(config?.models || []).map((model) => (
                                                            <div
                                                                key={model.id}
                                                                className="rl-field-group"
                                                                style={{ paddingBottom: '16px' }}
                                                            >
                                                                <label className="rl-label">{model.name}</label>

                                                                <input
                                                                    type="text"
                                                                    className="rl-input"
                                                                    placeholder={model.valueLabel || 'Insira o valor do modelo'}
                                                                    value={selectedModels[key]?.[model.id]?.value || ''}
                                                                    onChange={(e) =>
                                                                        handleModelValueChange(key, model.id, e.target.value)
                                                                    }
                                                                    readOnly={isActivated}
                                                                />
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                            ) : (
                                                renderFields(selectedUser, activeResource)
                                            )}
                                        </div>
                                    );
                                })()
                            ) : (
                                <div className="rl-empty">
                                    <p>
                                        {userDynamicResources.length === 0
                                            ? "Nenhum recurso adicionado. Clique em '+ Adicionar recurso'."
                                            : "Selecione uma aba para configurar o recurso."}
                                    </p>
                                </div>
                            )}
                        </>
                    )}
                </main>
            </div>

            {/* ── MODAL: NOVO GRUPO ── */}
            {showPopup && (
                <div className="rl-overlay" role="dialog" aria-modal="true">
                    <div className="rl-modal" onClick={(e) => e.stopPropagation()}>
                        <div className="rl-modal-header">
                            <h2>{tResource("create_resource_group")}</h2>
                            <img
                                src="/imagens/x.svg"
                                className="management-painel-btn-exit"
                                alt=""
                                onClick={handleExitPopup}
                            />
                        </div>

                        <div className="rl-field-group">
                            <label className="rl-label-black">{tResource("resource_group_name")}</label>
                            <input
                                type="text"
                                className={`rl-input${formTocado && !newBuName.trim() ? " rl-input--error" : ""
                                    }`}
                                placeholder={tResource("enter_business_unit_name")}
                                value={newBuName}
                                onChange={(e) => setNewBuName(e.target.value)}
                            />
                        </div>

                        {/* Seleção de domínios (reutiliza a estrutura atual) */}
                        <div className="rl-field-group">
                            <label className="rl-label-black">{tResource("select_business_unit")}</label>
                            <div className="rl-domain-list">
                                {availableDomains
                                    .filter((domain) => {
                                        const isAllowedForUser = domainsAccess.includes(domain.name);
                                        if (!isAllowedForUser) return false;
                                        // Pega apenas os domínios de grupos que NÃO são o Basic
                                        const usedDomains = Object.entries(domainSelections)
                                            .filter(([groupId]) => {
                                                const group = resourceUsers.find(u => String(u.id) === String(groupId));
                                                return !(group && group.isBasic); // Ignora se for o recurso básico
                                            })
                                            .flatMap(([, domainsArr]) => domainsArr);

                                        return !usedDomains.includes(domain.id);
                                    })
                                    .map((domain) => (
                                        <label key={domain.id} className="rl-domain-item">
                                            <input
                                                type="checkbox"
                                                checked={popupDomainSelections.includes(domain.id)}
                                                onChange={() => togglePopupDomainSelection(domain.id)}
                                            />
                                            {domain.name}
                                        </label>
                                    ))}
                            </div>
                        </div>

                        {/* Tipos de recurso inicial */}
                        <div className="rl-field-group">
                            <label className="rl-label-black">{tResource("resources")} *</label>
                            <div
                                className={`rl-resource-checklist${formTocado && selectedPopupResources.length === 0
                                    ? " rl-input--error"
                                    : ""
                                    }`}
                            >
                                {domains.map((domain) => (
                                    <label key={domain.id} className="rl-resource-check-item">
                                        <input
                                            type="checkbox"
                                            checked={selectedPopupResources.includes(domain.id)}
                                            onChange={() => {
                                                setSelectedPopupResources((prev) =>
                                                    prev.includes(domain.id)
                                                        ? prev.filter((id) => id !== domain.id)
                                                        : [...prev, domain.id]
                                                );

                                            }}
                                        />
                                        <span style={{ opacity: 1 }}>
                                            {domain.name}
                                        </span>
                                    </label>
                                ))}
                            </div>
                        </div>

                        <button
                            className="rl-btn rl-btn--primary rl-btn--full"
                            type="button"
                            onClick={handleAddBusinessUnit}
                            disabled={
                                blockPopupSave &&
                                (newBuName.trim() === "" ||
                                    Object.values(popupDomainSelections).every(
                                        (d) => d.length === 0
                                    ) ||
                                    selectedPopupResources.length === 0)
                            }
                        >
                            {isSavingBu ? tResource("saving") : tResource("save")}
                        </button>
                    </div>
                </div>
            )}
            {showResourcePopup && (
                <div className="rl-overlay" role="dialog" aria-modal="true">
                    <div className="rl-modal rl-modal--sm" onClick={(e) => e.stopPropagation()}>
                        <div className="rl-modal-header">
                            <h2>{tResource("create_resource_title")}</h2>
                                <img
                                    src="/imagens/x.svg"
                                    className="management-painel-btn-exit"
                                    alt=""
                                    onClick={handleExitResourcePopup}
                                />
                        </div>

                        <p className="rl-modal-sub">{tResource("resources")} *</p>

                        <div
                            className={`rl-resource-checklist${resourceListError ? " rl-input--error" : ""
                                }`}
                        >
                            {/* Filtra tipos que já existem no domínio — regra de negócio */}
                            {domains
                                .filter((domain) => {
                                    // domínios já no recurso atual
                                    const existingInCurrent = (dynamicResources[editingCardId] || [])
                                        .map((r) => r.name);

                                    // domínios usados em QUALQUER outro recurso
                                    const usedInOthers = Object.entries(dynamicResources)
                                        .filter(([id]) => {
                                            if (id === editingCardId) return false;

                                            // Encontra o grupo e verifica se ele é o Basic
                                            const group = resourceUsers.find(u => String(u.id) === String(id));
                                            return !(group && group.isBasic); // Retorna true (mantém no array) só se NÃO for básico
                                        })
                                        .flatMap(([, resources]) => resources.map((r) => r.name));
                                    return !existingInCurrent.includes(domain.name)
                                        && !usedInOthers.includes(domain.name);
                                })
                                .map((domain) => (
                                    <label key={domain.id} className="rl-resource-check-item">
                                        <input
                                            type="checkbox"
                                            checked={newResourceSelections.includes(domain.id)}
                                            onChange={() => {
                                                setNewResourceSelections((prev) =>
                                                    prev.includes(domain.id)
                                                        ? prev.filter((id) => id !== domain.id)
                                                        : [...prev, domain.id]
                                                );
                                                if (resourceListError) {
                                                    /* limpa erro quando usuário seleciona */
                                                }
                                            }}
                                        />
                                        {domain.name}
                                    </label>
                                ))}
                        </div>

                        <button
                            className="rl-btn rl-btn--primary rl-btn--full"
                            type="button"
                            onClick={handleAddResources}
                            disabled={
                                (resourcePopupAttemptedSubmit &&
                                    newResourceSelections.length === 0) ||
                                isSavingResources
                            }
                        >
                            {isSavingResources ? tResource("saving") : tResource("save")}
                        </button>
                    </div>
                </div>
            )}


            {/* ── MODAL: NOVO RECURSO (já filtra tipos existentes) ── */}


            {isDeleteCardModalOpen && (
                <div className="rl-overlay" role="dialog" aria-modal="true">
                    <div className="rl-modal rl-modal--sm" onClick={(e) => e.stopPropagation()}>
                        <div className="rl-modal-header">
                            <h2>{tResource("delete_resource_group")}</h2>
                            <button className="rl-btn-icon" onClick={handleCloseDeleteCardModal}>
                                ×
                            </button>
                        </div>
                        <p>{tResource("confirm_delete_resource_group")}</p>
                        <div style={{ display: "flex", gap: "8px" }}>
                            <button
                                className="rl-btn rl-btn--secondary rl-btn--full"
                                onClick={handleCloseDeleteCardModal}
                            >
                                {tResource("cancel")}
                            </button>
                            <button
                                className="rl-btn rl-btn--danger rl-btn--full"
                                onClick={handleConfirmCardDelete}
                            >
                                {tResource("delete")}
                            </button>
                        </div>
                    </div>
                </div>
            )}
            {isDeleteModalOpen && (
                <div className="rl-overlay" role="dialog" aria-modal="true">
                    <div className="rl-modal rl-modal--sm" onClick={(e) => e.stopPropagation()}>
                        <div className="rl-modal-header">
                            <h2>{tResource("delete_resource")}</h2>
                            <button className="rl-btn-icon" onClick={handleCloseDeleteModal}>
                                ×
                            </button>
                        </div>
                        <p>{tResource("confirm_delete_resource_group")}</p>
                        <div style={{ display: "flex", gap: "8px", }}>
                            <button
                                className="rl-btn rl-btn--secondary rl-btn--full"
                                onClick={handleCloseDeleteModal}
                            >
                                {tResource("cancel")}
                            </button>
                            <button
                                className="rl-btn rl-btn--danger rl-btn--full"
                                onClick={handleConfirmDelete}
                            >
                                {tResource("delete")}
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
}

// ─────────────────────────────────────────────
// CSS (injetado via <style> para facilitar cópia)
// ─────────────────────────────────────────────
const CSS = `
/* Reset mínimo */
.rl-root *, .rl-root *::before, .rl-root *::after { box-sizing: border-box; }

/* Layout raiz */
.rl-root {
  display: flex;
    height: 100%;
    min-height: 500px;
    
}

/* ── SIDEBAR ── */
.rl-sidebar {
    width: 340px;
    border-right: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    background-color: #02172B;
    border-radius: 16px 0 0 16px;
}

.rl-sidebar-header {
    padding: 12px 15px;
    display: flex;
    align-items: center;
}
.rl-sidebar-title { 
  font-weight: 600; 
  font-size: 12px; 
  text-transform: uppercase; 
  color: #0067FF; 
  letter-spacing: 1px;
}

.rl-user-item {
    display: flex;
    align-items: center;
    padding: 12px 15px;
    gap: 12px;
    cursor: pointer;
    position: relative;
    transition: background 0.2s;
    border-left: 3px solid transparent;
}
.rl-sidebar-search { padding: 10px 0 10px 10px; width: 100%; }
.rl-sidebar-search .rl-input { border-color: #2a2a4a; color: #000000; }
.rl-sidebar-search .rl-input::placeholder { color: #5555a0; }
.rl-search-wrapper { position: relative; display: flex; align-items: center; width: 100%; }
.rl-search-icon { position: absolute; left: 10px; width: 16px; height: 16px; pointer-events: none; opacity: 0.5; }
.rl-input--search { padding-left: 34px; }
.rl-user-list::-webkit-scrollbar, .rl-resource-panel::-webkit-scrollbar {
  width: 6px;
}
.rl-user-list::-webkit-scrollbar-thumb, .rl-resource-panel::-webkit-scrollbar-thumb {
  background: rgba(0, 103, 255, 0.3);
  border-radius: 10px;
}
.rl-user-item:hover {
    background: rgba(255, 255, 255, 0.05);
}

.rl-user-item--active {
    background: rgba(0, 103, 255, 0.1);
    border-left-color: #0067FF;
}
.rl-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    flex-shrink: 0; /* Impede o círculo de achatar */
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    background: #0067FF;
}
.rl-user-name {
    flex: 1;
    font-size: 14px;
    font-weight: 600;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis; /* Evita que nomes grandes quebrem o layout */
}

/* ── MAIN ── */
.rl-main { 
  flex: 1; 
  display: flex; 
  flex-direction: column; 
  background: transparent; 
}

.rl-main-header {
  padding: 24px;
}

.rl-main-header-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.rl-main-title { font-size: 22px; color: #fff; }

/* ── TABS ── */
.rl-tabs {
  display: flex;
  gap: 8px;
  padding: 0 24px;
}
.rl-tab {
  padding: 8px 18px;
  border-radius: 20px;
  border: 1px solid #0067FF;
  background: transparent;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
}
.rl-tab:hover { background:#001940; }
.rl-tab--active {
  background-color: #001940;
}

/* ── RESOURCE PANEL ── */
.rl-resource-panel {
  padding: 20px 30px;
  overflow-y: auto;
  flex: 1;
  min-height: 0;
  scrollbar-width: thin;
  scrollbar-color: #c1c1c1 transparent;
  margin-bottom: 7px;
}


.rl-resource-panel-header {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 10px;
  color: #fff;
}
.rl-resource-meta { display: flex; align-items: center; gap: 10px; }
.rl-resource-type { font-size: 16px; font-weight: 600; }

.rl-badge {
  padding: 2px 10px; border-radius: 20px;
  font-size: 11px; font-weight: 600;
  background: #fee; color: #c00;
}
.rl-badge--active { background: #e6faf0; color: #0a8a4a; }

.rl-resource-actions { display: flex; align-items: center; gap: 12px; }

/* ── FIELDS GRID ── */
.rl-fields-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.rl-field-group { display: flex; flex-direction: column; gap: 5px; }
.rl-field-group--full { grid-column: 1 / -1; }
.rl-label {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
}

.rl-label-black {
  font-size: 14px;
  font-weight: 500;
  color: #000;
}

/* ── INPUTS ── */
.rl-input {
  width: 100%;
  padding: 10px 0 12px 10px;
  border: none;
  border: 1px solid #C1C1C1;
  border-radius: 10px; /* Match com o padrão da Management */
  font-size: 14px;
  color: #000000;
  outline: none;
}

.rl-input:not([readonly])::placeholder {
  color: #C1C1C1 !important;
}
  
.rl-input--error { border-color: #e05; }
.rl-input--pointer { cursor: pointer; }
.rl-input:focus { border-color: #0067FF; }

.rl-input[readonly] {
  color: #aaa;
}

/* ── TAGS ── */
.rl-tags { display: flex; flex-wrap: wrap; gap: 6px; margin-top: 6px; }
.rl-tag {
  display: flex; align-items: center; gap: 4px;
  background: #ececff; color: #4040c0;
  border-radius: 4px; padding: 3px 8px; font-size: 12px;
}
.rl-tag button { background: none; border: none; cursor: pointer; color: #4040c0; padding: 0; line-height: 1; }

/* ── TOGGLE ── */
.rl-toggle { position: relative; display: inline-block; width: 40px; height: 22px; cursor: pointer; }
.rl-toggle input { opacity: 0; width: 0; height: 0; }
.rl-toggle-slider {
  position: absolute; inset: 0;
  background: #ccc; border-radius: 22px;
  transition: background .2s;
}
.rl-toggle-slider::before {
  content: ''; position: absolute;
  width: 16px; height: 16px; border-radius: 50%;
  background: #fff; left: 3px; top: 3px;
  transition: transform .2s;
}
.rl-toggle input:checked + .rl-toggle-slider { background: #0067FF; }
.rl-toggle input:checked + .rl-toggle-slider::before { transform: translateX(18px); }

/* ── MODEL SECTION ── */
.rl-model-section-header { display: flex; flex-direction: column; align-items: start; gap: 12px; margin-bottom: 16px; font-weight: 600; }
.rl-model-list { display: flex; flex-direction: column; gap: 8px; }
.rl-model-item { display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 13px; }

/* ── BUTTONS ── */
.rl-btn {
  padding: 8px 16px; border-radius: 80px; border: none;
  font-size: 14px; font-weight: 500; cursor: pointer;
  transition: opacity .15s, background .15s;
}
.rl-btn:disabled { opacity: .5; cursor: not-allowed; }
.rl-btn--primary {
  background: #E8F0F8;
  color: #000000;
  border-radius: 35px;
  padding: 10px 24px;
  text-transform: uppercase;
  font-size: 12px;
  letter-spacing: 0.5px;
}

.rl-btn--primary:hover:not(:disabled) { background: #cfd7df; }
.rl-btn--secondary { background: #ececff; color: #000000; }
.rl-btn--secondary:hover:not(:disabled) { background: #cfd7df; }

.rl-btn--danger {
  width: 80px; height: 37px; border-radius: 80px; border: none;
  font-size: 12px; font-weight: 500; color: #c00; cursor: pointer;
  transition: opacity .15s, background .15s;
}
.rl-btn--danger:hover:not(:disabled) { background: #ffd9d9; }
.rl-btn--ghost { background: transparent; color: #fff; border: 1px solid #d0d4e8; padding: 4px 16px;}
.rl-btn--ghost:hover { background: #001940; }
.rl-btn--full { width: 100%; margin-top: 8px; }

.management-painel-btn-exit {
  width: 16px; height: 16px;
  cursor: pointer;
  display: flex; align-items: center; justify-content: center;
}
.management-painel-btn-exit:hover { transform: scale(1.1); }

.rl-btn-icon {
  width: 28px; height: 28px; border-radius: 6px; border: none;
  font-size: 16px; font-weight: 700; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  background: #2a2a4a; color: #9090b8;
  transition: background .15s;
}
.rl-btn-icon:hover { background: #6c63ff; color: #fff; }
.rl-btn-icon--danger { background: transparent; color: #9090b8; }
.rl-btn-icon--danger:hover { background: #c00; color: #fff; }

.rl-btn-icon-header {
  min-width: 42px; height: 34px; border-radius: 80px; border: none;
  font-size: 32px; font-weight: 200; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  background: #E8F0F8;
}
.rl-btn-icon-header:hover { background: #cfd7df; }

/* ── EMPTY STATE ── */
.rl-empty { flex: 1; display: flex; align-items: center; justify-content: center; color: #9090b8; padding: 48px; text-align: center; }

/* ── MODAL ── */
.rl-overlay {
  position: fixed; inset: 0; background: rgba(10,10,30,.5);
  display: flex; align-items: center; justify-content: center;
  z-index: 1000;
}
.rl-modal {
  background: #FFFFFF; 
  color: #000000;
  border-radius: 12px;
  width: 480px; max-width: 95vw; max-height: 88vh;
  overflow-y: auto; padding: 28px;
  display: flex; flex-direction: column; gap: 18px;
  box-shadow: 0 8px 40px rgba(0,0,0,.18);
}
.rl-modal--sm { width: 360px; }
.rl-modal-header { display: flex; justify-content: space-between; align-items: center; }
.rl-modal-header h2 { margin: 0; font-size: 16px; }
.rl-modal-header .rl-btn-icon { background: #f0f0f8; color: #333; }
.rl-modal-sub { margin: 0; font-size: 12px; font-weight: 700; text-transform: uppercase; color: #000000; letter-spacing: .04em; }

/* ── DOMAIN / COUNTRY LIST ── */
.rl-domain-list { display: flex; flex-direction: column; gap: 8px; max-height: 220px; border-radius: 8px; }
.rl-country-group { display: flex; flex-direction: column; gap: 4px; }
.rl-country-label { display: flex; align-items: center; gap: 6px; font-weight: 600; cursor: pointer; }
.rl-domain-items { display: flex; flex-direction: column; gap: 3px; padding-left: 18px; }
.rl-domain-item { display: flex; align-items: center; gap: 6px; cursor: pointer; font-size: 13px; }
.rl-domain-item--disabled { opacity: .5; pointer-events: none; }
.rl-domain-item input[type="checkbox"] { -webkit-appearance: none; width: 15px; height: 15px; border: 1.5px solid #0067FF; border-radius: 3.5px; cursor: pointer; flex-shrink: 0; }
.rl-domain-item input[type="checkbox"]:checked { background-color: #0067FF; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 4l3 3 5-6' stroke='white' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: center; background-size: 9px; }

/* ── RESOURCE CHECKLIST ── */
.rl-resource-checklist { display: flex; flex-direction: column; gap: 8px; border-radius: 8px; }
.rl-resource-check-item { display: flex; align-items: center; gap: 8px; cursor: pointer; font-size: 13px; }
.rl-resource-check-item input[type="checkbox"] { -webkit-appearance: none; width: 15px; height: 15px; border: 1.5px solid #0067FF; border-radius: 3.5px; cursor: pointer; flex-shrink: 0; }
.rl-resource-check-item input[type="checkbox"]:checked { background-color: #0067FF; background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 10 8' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 4l3 3 5-6' stroke='white' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E"); background-repeat: no-repeat; background-position: center; background-size: 9px; }
`;